import { Product } from '../../lib/types/models/product/product'
import { ProductInput } from '../../lib/types/models/product/product-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createProduct(data: ProductInput) {
  return restApiClient
    .url(constructApiUrl(API.products.create.url, null))
    .post<Product, ProductInput>(data)
}
